<ng-container *transloco="let t">
  <p-dialog
    #dialog
    [visible]="display$ | async"
    (visibleChange)="onVisibleChange($event)"
    appendTo="body"
    [modal]="true"
    [dismissableMask]="false"
    [draggable]="false"
    [resizable]="false"
    [blockScroll]="true"
    styleClass="grid-load-dialog"
  >
    <p-header><i class="fad fa-folder-open mr-1"></i> {{ t('core.components.grid.load_dialog.title') }}</p-header>

    <div class="grid" [formGroup]="form" (keydown.enter)="load()">
      <div class="col-12 filters">
        <div class="p-fluid grid">
          <div class="field col-12">
            <z-loading-overlay target="load-listbox.p-listbox" [blocked]="loading$ | async" width="33rem" height="37.5rem">
              <i class="pi pi-spin pi-spinner" style="font-size: 2.5rem"></i>
            </z-loading-overlay>

            <p-listbox
              [filter]="true"
              filterPlaceHolder="{{ t('core.components.combo_box.filter_placeholder') }}"
              formControlName="saveId"
              [listStyle]="listHeight$ | async"
              optionDisabled="disabled"
              styleClass="load-listbox z-listbox z-listbox-small"
              [options]="savedGridDropdownList$ | async"
              optionLabel="column2"
              optionValue="column1"
              emptyMessage="{{ t('core.components.grid.load_dialog.empty_message') }}"
              (onDblClick)="onDoubleClick($event)"
            >
              <ng-template let-data pTemplate="item">
                <span class="no-uppercase">
                  {{ data['column2'] }}
                </span>
              </ng-template>
            </p-listbox>
          </div>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-toolbar styleClass="dialog-toolbar mt-4">
        <div class="p-toolbar-group-left">
          <p-button
            icon="fad fa-trash-can"
            label="{{ t('core.components.grid.load_dialog.remove') }}"
            styleClass="p-button-danger"
            [disabled]="
              (this.form.get('saveId').valueChanges | async) === false || (this.form.get('saveId').valueChanges | async) === 'default'
            "
            (click)="remove()"
          ></p-button>
        </div>

        <div class="p-toolbar-group-right">
          <p-button
            icon="fad fa-check"
            label="{{ t('core.components.grid.load_dialog.load') }}"
            styleClass="p-button-primary"
            [disabled]="(this.form.get('saveId').valueChanges | async) === false"
            (click)="load()"
          ></p-button>

          <p-button
            (click)="close()"
            label="{{ t('core.components.grid.load_dialog.cancel') }}"
            styleClass="p-button-secondary ml-2"
          ></p-button>
        </div>
      </p-toolbar>
    </ng-template>
  </p-dialog>
</ng-container>
